import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {}

const LoginHeaderTitle = (props: Props) => {
    const {t}=useTranslation();
  return (
    <div className="centered-container">
    <span className="sign-in-text">
      {t('sign_in_your_acc')}
    </span>
  </div>
  )
}

export default LoginHeaderTitle